import React, {FC} from 'react';
import {Link, useMatch} from "react-router-dom";
import {Box} from "@mui/material";
import {SetStatePropsType} from "@baseTypes/base";
import {INavigateItem} from "@view/navigate/types";
import NavigateItemContent from "@view/navigate/item/NavigateItemContent";

interface IProps {
	setVisibleMobileSidebar: SetStatePropsType<boolean>,
	navigate: INavigateItem,
}

const ItemNavigateRouter: FC<IProps> = ({
											setVisibleMobileSidebar,
											navigate,
										}) => {

	const active = !!useMatch({path: navigate.path, end: false})

	return (
		<Link
			key={navigate.path}
			to={navigate.path}
		>
			<Box
				onClick={() => setVisibleMobileSidebar(false)}
			>
				<NavigateItemContent
					navigate={navigate}
					active={active}
				/>
			</Box>
		</Link>
	);
};

export default ItemNavigateRouter;
